module.exports = __webpack_public_path__ + "static/media/twitter.21184f29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/twitter.svg
// module id = 243
// module chunks = 0